import { Shield, Zap, Globe, Users, Target, Award } from 'lucide-react';
import './CompanyPages.css';

const AboutPage = () => {
  const values = [
    { icon: Shield, title: 'Security First', desc: 'Your assets protection is our top priority' },
    { icon: Zap, title: 'Speed', desc: 'Lightning-fast exchanges worldwide' },
    { icon: Globe, title: 'Accessibility', desc: 'Crypto for everyone, everywhere' },
    { icon: Users, title: 'Community', desc: 'Built by the community, for the community' },
  ];

  const stats = [
    { value: '$2B+', label: 'Volume Traded' },
    { value: '1M+', label: 'Happy Users' },
    { value: '150+', label: 'Countries' },
    { value: '1000+', label: 'Supported Coins' },
  ];

  return (
    <div className="company-page">
      <div className="company-bg">
        <div className="company-glow"></div>
      </div>

      <div className="company-container">
        {/* Hero */}
        <section className="company-hero">
          <h1 className="company-title">
            About <span className="gradient-text">Omini Bridge</span>
          </h1>
          <p className="company-subtitle">
            We&apos;re on a mission to make cryptocurrency exchanges fast, secure, and accessible to everyone.
            Founded in 2020, we&apos;ve grown to become one of the most trusted exchange platforms in the world.
          </p>
        </section>

        {/* Stats */}
        <section className="company-stats">
          {stats.map((stat, index) => (
            <div key={index} className="company-stat">
              <span className="company-stat-value">{stat.value}</span>
              <span className="company-stat-label">{stat.label}</span>
            </div>
          ))}
        </section>

        {/* Mission */}
        <section className="mission-section">
          <div className="mission-content">
            <Target size={48} className="mission-icon" />
            <h2>Our Mission</h2>
            <p>
              To bridge the gap between traditional finance and the new world of cryptocurrency. 
              We believe everyone should have access to fast, secure, and affordable crypto exchanges, 
              regardless of their technical expertise or location.
            </p>
          </div>
        </section>

        {/* Values */}
        <section className="values-section">
          <h2>Our Values</h2>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card" style={{ animationDelay: `${index * 0.1}s` }}>
                <value.icon size={32} />
                <h3>{value.title}</h3>
                <p>{value.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Team CTA */}
        <section className="team-cta">
          <Award size={48} className="team-icon" />
          <h2>Join Our Team</h2>
          <p>We&apos;re always looking for talented people to join our growing team</p>
          <button className="team-btn">View Open Positions</button>
        </section>
      </div>
    </div>
  );
};

export default AboutPage;
